/**
 * 组件类型
 */
export enum CompTypeEnum {
  //单选
  Radio = 'radio',
  //按钮样式单选
  RadioButton = 'radioButton',
  //下拉框
  Select = 'select',
  //列表
  List = 'list',
  //开关
  Switch = 'switch',
  //下拉树
  SelTree = 'sel_tree',
  //分类字典树
  CatTree = 'cat_tree',
  //下拉搜索
  SelSearch = 'sel_search',
  //用户现在框
  SelUser = 'sel_user',
  //复选框
  Checkbox = 'checkbox',
  //多选列表
  ListMulti = 'list_multi',
  //区域选择
  Pca = 'pca',
  Popup = 'popup',
  //部门选择
  SelDepart = 'sel_depart',
}
